var LayerSelectorOverlay = function (data, opts) {};

module.exports = LayerSelectorOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/vis/overlays/layer_selector.js
// module id = 1695
// module chunks = 6